@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="Katalog-Quelle auswählen"
           [ngModel]="filterText()"
           fullWidth
           [disabled]="true" />
  </nb-form-field>
} @else {
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput
           type="text"
           [(ngModel)]="filterText"
           placeholder="Katalog-Quelle auswählen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth
           data-cy="catalog-source-tenant-select" />
    @if (value) {
      <button nbSuffix nbButton ghost (click)="onClear()" data-cy="catalog-source-tenant-clear">
        <nb-icon icon="close-outline" pack="eva"></nb-icon>
      </button>
    }
  </nb-form-field>
}

<ng-template #popoverTemplate>
  <div class="autocomplete-dropdown">
    <nb-list>
      @for (tenant of filteredTenants(); track tenant.id) {
        <nb-list-item (click)="onSelectionChange(tenant)">
          <div class="tenant-item" [attr.data-cy]="'catalog-source-option-' + tenant.name">{{ tenant.name }}</div>
        </nb-list-item>
      } @empty {
        <nb-list-item>
          <div class="tenant-item no-items">Keine passenden Firmen im Konzern gefunden</div>
        </nb-list-item>
      }
    </nb-list>
  </div>
</ng-template>
